<template>
  <div>
    <template v-if="!selectedClaim">
      <div class="form-group-without-margin">
        <inputbox
          name="incident_selector"
          label="Claim"
          helper="Type a claim reference and then select the relevant claim"
          :value="claimNumber"
          @input="emitSearch"
          :show-error="showError"
          :error-message="errorMessage"
        ></inputbox>
      </div>

      <div class="col-md-8 offset-md-4 mb-3 mt-2">
        <ul class="list-group">
          <li
            class="list-group-item list-group-item-action"
            :key="key"
            v-for="(result, key) in results"
            @click="select(result)"
          >
            {{ result.source.claim_reference }}
          </li>
        </ul>
      </div>
    </template>

    <template v-if="selectedClaim">
      <div class="form-group-without-margin">
        <inputbox
          name="incident_selector"
          label="Claim"
          helper="Type a claim reference and then select the relevant claim"
          :value="selectedClaim.source?.claim_reference"
          :readonly="true"
        ></inputbox>
      </div>
      <div class="col-md-8 offset-md-4 mb-3">
        <small>
          <a @click="clearClaim" class="cursor-pointer"
            >Click here to change the claim</a
          >
        </small>
      </div>
    </template>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';

export default {
  props: {
    value: {
      type: Number
    },
    results: {
      type: Array,
      required: true
    },
    claim: {
      type: Object
    },
    errorMessage: {
      type: String
    },
    showError: {
      type: Boolean,
      default: () => false
    }
  },

  data() {
    return {
      claimNumber: undefined,
      selectedClaim: undefined
    };
  },

  mounted() {
    if (this.claim) {
      this.selectedClaim = this.claim;
      this.claimNumber = this.claim.source?.claim_reference;
    }
  },

  methods: {
    emitSearch: debounce(function(value) {
      if (this.value != value) {
        this.$emit('search', value);
      }
    }, 400),

    select(claim) {
      this.$emit('input', claim.id);

      this.selectedClaim = claim;
    },

    clearClaim() {
      this.selectedClaim = undefined;
      this.$emit('input', null);
    }
  },

  watch: {
    claim(claim) {
      if (claim) {
        this.selectedClaim = claim;
        this.claimNumber = claim.source?.claim_reference;
      }
    }
  }
};
</script>

<style lang="scss">
.form-group-without-margin {
  .form-group,
  .help-block {
    margin-bottom: 0;
  }
}
</style>
